import { render, staticRenderFns } from "./zTituloTela.vue?vue&type=template&id=765dbb0c&scoped=true&"
import script from "./zTituloTela.vue?vue&type=script&lang=js&"
export * from "./zTituloTela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765dbb0c",
  null
  
)

export default component.exports